<template>
    <div class="roma-page-content fill-height grey lighten-4">
        <TaskCard :task="task" />

        <div class="task-detail">
            <v-row>
                <v-col md="6">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                
                                <p class="title">Respuesta del Estudiante</p>
                                
                                <!--<p class="title">
                                    {{
                                        task.lessonTO.subject.abbreviation +
                                            " " +
                                            task.lessonTO.section
                                                .nameAndCategoryName +
                                            " - " +
                                            task.lessonTO.title +
                                            " - " +
                                            task.activityTO.title
                                    }}
                                </p>-->
                            </v-col>
                        </v-row>
                        <!--<v-row>
                            <v-col cols="12">
                                <p>
                                    {{
                                        task.student.identificationCode +
                                            " - " +
                                            task.student.fullName
                                    }}
                                </p>
                            </v-col>
                        </v-row>-->
                        
                        <!--<v-row>
                            <v-col>
                                <p>Respuesta del estudiante</p>
                            </v-col>
                        </v-row>-->

                        <v-row v-if="task.taskDescription">
                            <v-col>
                                <quillEditor
                                    class="lesson-detail__quill"
                                    :content="task.taskDescription"
                                    :options="editorOption"
                                    :disabled="true"
                                />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <template
                                    v-for="(file, i) in task.taskFileList"
                                >
                                    <v-chip
                                        :key="i"
                                        v-if="file.proprietary == 'STUDENT'"
                                        class="ma-2"
                                        link
                                        target="_blank"
                                        :href="`${link}${file.taskFileId}`"
                                        color="orange"
                                        text-color="white"
                                    >
                                        <v-avatar left>
                                            <v-icon>mdi-download</v-icon>
                                        </v-avatar>
                                        {{ file.fileName }}
                                    </v-chip>
                                </template>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
                <v-col md="6">
                    <v-form v-model="isValid">
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <p class="title">Evaluación</p>
                                </v-col>
                            </v-row>

                            <!-- <template v-if="!task.taskCheckedDate"> -->
                            <template>
                                <v-row v-if="task.activityTO" >

                                    <v-col
                                        v-if="task.activityTO.maxScore"
                                    >
                                        <v-text-field
                                                dense
                                                :disabled=true
                                                label="Puntaje Máximo"
                                                outlined
                                                rounded
                                                v-model="task.activityTO.maxScore"
                                                type="number"
                                            ></v-text-field>
                                    </v-col>

                                    <v-col>
                                        <v-text-field
                                                dense
                                                label="Puntaje Obtenido"
                                                outlined
                                                rounded
                                                v-model="scoreGoal"
                                                :rules="rules.scoreGoal"
                                                type="number"
                                            ></v-text-field>
                                    </v-col>

                                    <v-col
                                        v-if="
                                            task.activityTO.evaluationFormat ==
                                                'NOTA' ||
                                                task.activityTO.evaluationFormat ==
                                                    'NOTA_LOGRO'
                                        "
                                    >
                                    <v-text-field
                                            dense
                                            min="0"
                                            max="7"
                                            :rules="rules.score"
                                            label="Nota"
                                            outlined
                                            rounded
                                            v-model="score"
                                            :disabled=true
                                            type="number"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        v-if="
                                            task.activityTO.evaluationFormat ==
                                                'LOGRO' ||
                                                task.activityTO.evaluationFormat ==
                                                    'NOTA_LOGRO'
                                        "
                                    >
                                        <v-text-field
                                            dense
                                            label="Logro"
                                            min="0"
                                            max="100"
                                            :rules="rules.achievement"
                                            outlined
                                            rounded
                                            placeholder="% logro"
                                            maxlength="3"
                                            v-model="achievement"
                                            :disabled=true
                                            type="number"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class=" py-0">
                                        <v-checkbox
                                            class=" ma-0"
                                            v-model="isFeedback"
                                            label="Adicionar retroalimentación"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row v-if="this.isFeedback">
                                    <v-col>
                                        <span
                                            >Retroalimentación al
                                            estudiante</span
                                        >
                                        <TipTap
                                            placeholder="Por favor indique sus instrucciones"
                                            :data="setFeedback"
                                            :updateMode="{
                                                status: $route.params.id
                                                    ? true
                                                    : false,
                                                currentSelected: $route.params
                                                    .id
                                                    ? this.feedback
                                                    : ''
                                            }"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row v-if="task.taskFileList">
                                    <v-col>
                                        <template
                                            v-for="(file,
                                            i) in task.taskFileList"
                                        >
                                            <v-chip
                                                :key="i"
                                                v-if="
                                                    file.proprietary ==
                                                        'TEACHER'
                                                "
                                                class="ma-2"
                                                link
                                                target="_blank"
                                                :href="
                                                    `${link}${file.taskFileId}`
                                                "
                                                color="orange"
                                                text-color="white"
                                                close
                                                @click:close="remove(file)"
                                            >
                                                <v-avatar left>
                                                    <v-icon
                                                        >mdi-download</v-icon
                                                    >
                                                </v-avatar>
                                                {{ file.fileName }}
                                            </v-chip>
                                        </template>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-file-input
                                            placeholder="Subir Archivos"
                                            outlined
                                            dense
                                            chips
                                            counter
                                            multiple
                                            show-size
                                            rounded
                                            truncate-length="15"
                                            v-model="filesTask"
                                        ></v-file-input>
                                    </v-col>

                                    <v-col>
                                        <v-btn
                                            rounded
                                            color="blue"
                                            class="white--text"
                                            block
                                            @click="createOrUpdate()"
                                            :disabled="!isValid"
                                            >Guardar</v-btn
                                        >
                                    </v-col>
                                </v-row>
                            </template>

                            <!-- <template v-else>
                                <v-row>
                                    <v-col>
                                        <v-icon color="green">mdi-check</v-icon>
                                        Se ha realizado la evaluación de esta
                                        actividad
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col
                                        v-if="
                                            task.activityTO?.evaluationFormat ==
                                                'NOTA' ||
                                                task.activityTO?
                                                    .evaluationFormat ==
                                                    'NOTA_LOGRO'
                                        "
                                    >
                                        <p>Nota: {{ task.score }} pts</p>
                                    </v-col>

                                    <v-col
                                        v-if="
                                            task.activityTO?.evaluationFormat ==
                                                'LOGRO' ||
                                                task.activityTO
                                                    .evaluationFormat ==
                                                    'NOTA_LOGRO'
                                        "
                                    >
                                        <p>Logro: {{ task.achievement }}</p>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col>
                                        <h3>Retroalimentación:</h3>
                                        <quillEditor
                                            class="lesson-detail__quill"
                                            :content="task.feedback"
                                            :options="editorOption"
                                            :disabled="true"
                                        />
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col>
                                        <template
                                            v-for="(file,
                                            i) in task.taskFileList"
                                        >
                                            <v-chip
                                                :key="i"
                                                v-if="
                                                    file.proprietary ==
                                                        'TEACHER'
                                                "
                                                class="ma-2"
                                                link
                                                target="_blank"
                                                :href="
                                                    `${link}${file.taskFileId}`
                                                "
                                                color="orange"
                                                text-color="white"
                                            >
                                                <v-avatar left>
                                                    <v-icon
                                                        >mdi-download</v-icon
                                                    >
                                                </v-avatar>
                                                {{ file.fileName }}
                                            </v-chip>
                                        </template>
                                    </v-col>
                                </v-row>
                            </template> -->
                        </v-container>
                    </v-form>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import TaskCard from "@/components/task/TaskCard.vue";
import TipTap from "@/components/commons/RomaTipTap";

import { quillEditor } from "vue-quill-editor";
import { mapActions, mapGetters } from "vuex";

export default {
    components: { TaskCard, TipTap, quillEditor },
    data() {
        return {
            editorOption: {
                readOnly: true,
                modules: {
                    toolbar: false
                },
                placeholder: ''
            },
            filesTask: [],
            score: '',
            scoreGoal:'',
            achievement: '',
            feedback: "",
            isFeedback: false,
            rules: {
                score: [
                    v => !!v || "Este campo es requerido"//,
                    //v => v <= 7 || "El campo debe ser menor o igual a 7"
                ],
                achievement: [
                    v => !!v || "Este campo es requerido"//,
                    //v => v <= 100 || "El campo debe ser menor o igual a 100"
                ],
                scoreGoal: [
                    v => !!v || "Este campo es requerido"//,
                ]
            },
            isValid: true
        };
    },
    computed: {
        ...mapGetters({
            task: "getCurrentTask"
        }),
        link() {
            return `${process.env.VUE_APP_ROMA_PLANNER_API_URL}file/dowload/task/`;
        }
    },
    async mounted() {
        // this.updateItem
        //     ? await this.actionGetLesson(this.updateItem)
        //     : this.resetLessonUpdate();

        if (this.$route.params.id) {
            console.log("CONSULTANDO");
            await this.actionGetTask({ taskId: this.$route.params.id });
            this.updateMode(this.task);
        }

        // await this.actionGetInformationLesson(this.getInstitutionId);
        // this.$route.params.id ? this.updateMode(this.getLesson) : false;
    },
    methods: {
        ...mapActions({
            actionGetTask: "actionGetTask",
            actionSendTaskFeedback: "actionSendTaskFeedback",
            toastSuccess: "toastSuccess",
            setFileList: "setTask"
        }),
        remove (item) {
            console.log("Removiendo item ",item);
            const newTask = this.task;
            newTask.taskFileList.splice(newTask.taskFileList.indexOf(item), 1);
            newTask.taskFileList = [...newTask.taskFileList]
            console.log(newTask);
            this.setFileList(newTask);
        },
        setFeedback(feedback) {
            this.feedback = feedback;
        },
        updateMode(data) {
            if (data) {
                this.score = data.score ? data.score : '';
                this.achievement = data.achievement ? data.achievement : '';
                this.feedback = data.feedback;
                this.isFeedback = data.feedback ? true : false;
                this.scoreGoal = data.scoreGoal;
            }
        },

        createOrUpdate() {
            //only send
            this.sendTaskFeedback();
        },

        sendTaskFeedback() {
            const form = new FormData();

            form.append("taskId", this.task.taskId);
            form.append("feedback", this.feedback);
            form.append("score", this.score ? this.score : 0);
            form.append("scoreGoal",this.scoreGoal);

            this.achievement
                ? form.append("achievement", this.achievement)
                : form.append("achievement", 0);

            this.filesTask.forEach((element, i) => {
                form.append("files", this.filesTask[i]);
            });

            this.task.taskFileList.forEach((element, i) => {
                form.append("filesStored",this.task.taskFileList[i].taskFileId);
            });            

            console.log("### ENVIAR RETROALIMENTACION ###");
            for (const pair of form.entries()) {
                console.log(pair[0] + ", " + pair[1]);
            }

            this.actionSendTaskFeedback(form)
                .then(() => {
                    this.toastSuccess({
                        message: `Se ha evaluado la actividad`
                    });
                    this.goBack();
                })
                .catch(error => console.log(error));
        }
        ,
        getCalificacion(notaMinima,notaMaxima,notaAprobatoria,exigencia,puntajeMaximo, puntajeObtenido) {

        if(puntajeObtenido == null){
            return;
        }

        console.log("notaMinima: " + notaMinima + " - notaMaxima: " + notaMaxima + " - notaAprobatoria: " + notaAprobatoria+ " - exigencia: " + exigencia);
        console.log("puntajeMaximo: " + puntajeMaximo + " - puntajeObtenido: " + puntajeObtenido);

        let porcentajeObtenido = 0;
        if (puntajeMaximo > 0) {
            porcentajeObtenido = puntajeObtenido / puntajeMaximo * 100;
        }

        let x1, x2, y1, y2;
        if (porcentajeObtenido < exigencia) {
            x1 = 0;
            x2 = ((puntajeMaximo * exigencia) / 100);
            y1 = notaMinima;
            y2 = notaAprobatoria;
        } else {
            x1 = (puntajeMaximo * exigencia) / 100;
            x2 = puntajeMaximo;
            y1 = notaAprobatoria;
            y2 = notaMaxima;
        }

        let m = 0;
        if (x1 != x2) {
            m = (y2 - y1) / (x2 - x1);
        }

        const nota = Math.round((puntajeObtenido * m + (y1 - (m * x1))) * 10) / 10;

        console.log("Puntaje: " + puntajeObtenido + " - Nota: " + nota + " - PorcentajeObtenido: " + porcentajeObtenido);

        this.score = nota;
        this.achievement = porcentajeObtenido.toFixed(2);

    }
    },
    watch: {     
	    /*score: function() {             
            if(this.score>7){
                this.score = 7;
            }             
            if(this.score>0){
                this.achievement = ((this.score * 100) / 7).toFixed(2);	  
            }              
	    },*/
	    scoreGoal: function() {                       
            this.getCalificacion(this.task.activityTO.minScoreConfig,
            this.task.activityTO.maxScoreConfig,
            this.task.activityTO.approvingGrade,
            this.task.activityTO.percentageRequirement,
            this.task.activityTO.maxScore,
            this.scoreGoal);  
	    }

    }
};
</script>

<style lang="scss" scoped>
.task-detail {
    margin-top: 0.5rem;
    width: 100%;
    padding-bottom: 0%;
    background: #ffffff;
    border-radius: 5px;
    //   padding: 1rem;
    // box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    //     0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);

    .title {
        color: #539dd4;
    }
}
.lesson-detail__quill {
    .ql-container.ql-snow {
        border: none !important;
    }
}
</style>
